/* Central job data — used by the careers listing page and the job
   detail page template. Add new open roles here as an object in
   `openJobs`; each needs a unique `slug` (used in the URL). */

export const openJobs = [
  {
    slug: "digital-marketing-executive",
    title: "Digital Marketing Executive",
    location: "Remote",
    workModel: "Remote — work from anywhere in India",
    employmentType: "Full Time, Permanent",
    experience: "0 - 1 years",
    compensation: "Performance-based",
    department: "Marketing & Communication",
    industry: "Events & Consumer Services",
    openings: 1,
    responsibilities: [
      "Develop and execute digital marketing strategy across social media, WhatsApp, and web platforms",
      "Manage and grow Nirkana's social presence, keeping brand voice and visuals consistent",
      "Plan and run paid campaigns (Meta Ads, Google Ads) to drive quote requests ahead of launch",
      "Create and schedule content — posts, reels, and stories — covering the birthday launch and beyond",
      "Track performance and put together simple weekly reports on what's working",
      "Work directly with the founders to align marketing with what's actually being booked",
    ],
    profile: [
      "Any degree or diploma; formal marketing education is a plus but not required",
      "0–1 year of experience in digital or social media marketing",
      "Working knowledge of Instagram/Facebook tools, and comfort with basic analytics",
      "Can create and post content independently, without heavy oversight",
      "Clear written communication — you'll often be the voice of Nirkana online",
      "Comfortable in a small, early-stage team where things change fast",
    ],
    perks: [
      "Real ownership of a brand's digital presence from near-zero, not a small slice of a big team's work",
      "Fully remote, flexible hours around a small set of weekly check-ins",
      "Performance-based pay that grows as the results do",
      "Direct access to the founders — no layers to work through",
    ],
    skills: [
      "Social Media Marketing",
      "Content Creation",
      "Online Advertising",
      "Instagram Marketing",
      "Campaign Management",
      "Analytics & Reporting",
    ],
  },
  {
    slug: "admin-executive",
    title: "Admin Executive",
    location: "Chennai, Tamil Nadu",
    workModel: "Work from office — Chennai",
    employmentType: "Full Time, Permanent",
    experience: "Fresher – 1 year",
    compensation: "₹8,000 in-hand per month (₹96,000 per annum)",
    pfStatus: "Not currently applicable — Nirkana has fewer than 20 employees, the statutory threshold for mandatory EPF registration under Indian law. This will apply automatically once the company crosses that threshold.",
    department: "Administration",
    industry: "Events & Consumer Services",
    openings: 1,
    responsibilities: [
      "Handle day-to-day office administration — calls, emails, and scheduling",
      "Maintain records for bookings, vendor communication, and partner follow-ups",
      "Support the founders with documentation, data entry, and basic reporting",
      "Coordinate routine follow-ups between customers, vendors, and the team",
      "Keep office files, supplies, and basic operations organized and on track",
    ],
    profile: [
      "Any degree; fresher or up to 1 year of relevant admin/office experience",
      "Comfortable with MS Office / Google Workspace (Docs, Sheets, Gmail)",
      "Organized and reliable, with good follow-through on tasks",
      "Clear communication in English and Tamil",
      "Based in or able to commute to Chennai — this is an office role, not remote",
    ],
    perks: [
      "Hands-on exposure across a growing startup, not siloed into one narrow task",
      "Direct mentorship from the founders",
      "Real potential for growth in scope and pay as Nirkana scales past launch",
    ],
    skills: [
      "Office Administration",
      "MS Office",
      "Documentation",
      "Scheduling",
      "Data Entry",
      "Communication",
    ],
  },
];

/* Roles we expect to open later. Shown on the careers page as a
   preview so interested candidates can reach out early, but without
   a full job description or application flow yet. */
export const upcomingJobs = [
  { title: "Flutter Developer", experience: "3+ years", department: "Technology & Engineering" },
  { title: "Node.js Developer", experience: "3+ years", department: "Technology & Engineering" },
  { title: "Database Administrator", experience: "3+ years", department: "Technology & Engineering" },
  { title: "AI Engineer", experience: "1+ years", department: "Technology & Engineering" },
  { title: "Accounts Executive", experience: "2+ years", department: "Finance & Accounts", openings: 3 },
];
